import { useEffect, useState } from 'react';
import { useFormFieldEffect } from '../..';
import {
  FormField,
  StripeCheckoutCardPaymentFormGroup,
  validateLength,
  validateRequired,
} from '../..';

export interface StripeCheckoutCardPaymentFormFields {
  cardHolderName: string | null;
  cardNumber: string | null;
  cardExpiry: string | null;
  cardCvc: string | null;
}

export const useStripeCheckoutCardPaymentFormEffect =
  (): StripeCheckoutCardPaymentFormGroup => {
    const [isValid, setValid] = useState(false);
    const [isClean, setClean] = useState(false);
    const [isSubmitted, setSubmitted] = useState(false);

    const cardHolderName = useFormFieldEffect(
      'cardHolderName',
      'text',
      [validateRequired, validateLength],
      { required: true, minLength: 3, maxLength: 64 }
    );
    const cardNumber = useFormFieldEffect(
      'cardNumber',
      'text',
      [validateRequired, validateLength],
      { required: true, minLength: 16, maxLength: 16 }
    );
    const cardExpiry = useFormFieldEffect(
      'cardExpiry',
      'text',
      [validateRequired, validateLength],
      { required: true, minLength: 4, maxLength: 4 }
    );
    const cardCvc = useFormFieldEffect(
      'cardCvc',
      'text',
      [validateRequired, validateLength],
      { required: true, minLength: 3, maxLength: 3 }
    );

    const members = {
      cardHolderName,
      cardNumber,
      cardExpiry,
      cardCvc,
    };

    useEffect(() => {
      let valid = true;
      let clean = true;

      const formFields = members as any as { [key: string]: FormField };

      for (const i in formFields) {
        if (!formFields[i].isValid) {
          valid = false;
        }

        if (!formFields[i].isClean) {
          clean = false;
        }
      }

      if (isValid !== valid) {
        setValid(valid);
      }

      if (isClean !== clean) {
        setClean(clean);
      }
    }, [members, isClean, setClean, isValid, setValid]);

    const getFieldValues = (): StripeCheckoutCardPaymentFormFields => {
      return {
        cardHolderName: (members.cardHolderName.value as string) || null,
        cardNumber: (members.cardNumber.value as string) || null,
        cardExpiry: (members.cardExpiry.value as string) || null,
        cardCvc: (members.cardCvc.value as string) || null,
      };
    };

    const resetFieldValues = (clean = false) => {
      members.cardHolderName.doReset(clean);
      members.cardNumber.doReset(clean);
      members.cardExpiry.doReset(clean);
      members.cardCvc.doReset(clean);
    };

    return {
      isValid,
      isClean,
      isSubmitted,
      setValid,
      setClean,
      setSubmitted,
      getFieldValues,
      resetFieldValues,
      members,
    };
  };
